// extracted by css-extract-rspack-plugin
var _1 = "score-ZILAGx";
var _2 = "severity-CRITICAL-pQohY0";
var _3 = "severity-HIGH-XLwJkL";
var _4 = "severity-LOW-jTUDrm";
var _5 = "severity-MEDIUM-nDa7dH";
var _6 = "severity-NONE-j4H8hp";
var _7 = "severity-UNKNOWN-o4nJ2G";
var _8 = "severity-border-CRITICAL-DZBo5a";
var _9 = "severity-border-HIGH-uYcxb5";
var _a = "severity-border-LOW-SNymA4";
var _b = "severity-border-MEDIUM-fYFGsi";
var _c = "severity-border-NONE-yqh7cp";
var _d = "severity-border-UNKNOWN-KyJhNF";
var _e = "severity-border-CRITICAL-DZBo5a";
var _f = "severity-border-HIGH-uYcxb5";
var _10 = "severity-border-LOW-SNymA4";
var _11 = "severity-border-MEDIUM-fYFGsi";
var _12 = "severity-border-NONE-yqh7cp";
var _13 = "severity-border-UNKNOWN-KyJhNF";
var _14 = "severity-CRITICAL-pQohY0";
var _15 = "severity-HIGH-XLwJkL";
var _16 = "severity-LOW-jTUDrm";
var _17 = "severity-MEDIUM-nDa7dH";
var _18 = "severity-NONE-j4H8hp";
var _19 = "severity-UNKNOWN-o4nJ2G";
export { _1 as "score", _2 as "severity-CRITICAL", _3 as "severity-HIGH", _4 as "severity-LOW", _5 as "severity-MEDIUM", _6 as "severity-NONE", _7 as "severity-UNKNOWN", _8 as "severity-border-CRITICAL", _9 as "severity-border-HIGH", _a as "severity-border-LOW", _b as "severity-border-MEDIUM", _c as "severity-border-NONE", _d as "severity-border-UNKNOWN", _e as "severityBorderCRITICAL", _f as "severityBorderHIGH", _10 as "severityBorderLOW", _11 as "severityBorderMEDIUM", _12 as "severityBorderNONE", _13 as "severityBorderUNKNOWN", _14 as "severityCRITICAL", _15 as "severityHIGH", _16 as "severityLOW", _17 as "severityMEDIUM", _18 as "severityNONE", _19 as "severityUNKNOWN" }
